import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, auth } from "@/lib/api";
import Navbar from "@/components/Navbar";

export default function CustomerRegister() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const mobile = params.get("mobile") || "";
  const [form, setForm] = useState({
    name: "",
    address: "",
    location: "",
  });
  const [loading, setLoading] = useState(false);

  if (!mobile) {
    navigate("/customer/login");
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.address || !form.location) {
      return toast.error("Please fill all fields");
    }
    setLoading(true);
    try {
      const r = await api.post("/customers/register", { mobile, ...form });
      auth.setSession(r.data.token, "customer", r.data.user);
      toast.success("Welcome to OCTA Services!");
      navigate("/customer/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar variant="dashboard" />
      <div className="max-w-2xl mx-auto px-6 lg:px-10 py-16 fade-in">
        <div className="text-xs uppercase tracking-widest text-[#1E3F20] font-semibold">
          Complete your profile
        </div>
        <h1 className="font-display text-4xl mt-3">A few quick details</h1>
        <p className="text-[#4A4A4A] mt-3">
          Mobile: <strong>{mobile}</strong>
        </p>

        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="customer-register-form">
          <div>
            <label className="text-sm font-medium">Full name</label>
            <input
              className="octa-input mt-2"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Your full name"
              data-testid="customer-register-name"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Address</label>
            <textarea
              className="octa-input mt-2"
              value={form.address}
              onChange={(e) => setForm({ ...form, address: e.target.value })}
              placeholder="House no., street, area"
              data-testid="customer-register-address"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Location (City / Pincode)</label>
            <input
              className="octa-input mt-2"
              value={form.location}
              onChange={(e) => setForm({ ...form, location: e.target.value })}
              placeholder="e.g. Delhi - 110001"
              data-testid="customer-register-location"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="h-12 px-8 rounded-full btn-accent font-semibold disabled:opacity-50"
            data-testid="customer-register-submit"
          >
            {loading ? "Creating account..." : "Create account"}
          </button>
        </form>
      </div>
    </div>
  );
}
